import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'

Vue.config.productionTip = false

Vue.use(ElementUI)

Vue.prototype.$http = axios
console.log('API Base URL:', process.env.VUE_APP_API_BASE_URL)
Vue.prototype.$ossBaseURL = 'https://oss.cylm.fun/'

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
